import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';
import ContentLoading from '../../../components/ContentLoading';
import styles from './QuestionsEditor.m.sass';
import { QuestionRenderer } from './QuestionRenderer';
import { Help, getError } from '../../../components/Form';
var QuestionsEditor = observer(_class = /*#__PURE__*/function (_React$Component) {
  function QuestionsEditor() {
    _classCallCheck(this, QuestionsEditor);
    return _callSuper(this, QuestionsEditor, arguments);
  }
  _inherits(QuestionsEditor, _React$Component);
  return _createClass(QuestionsEditor, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onChange = _this$props.onChange,
        questions = _this$props.questions,
        answers = _this$props.answers,
        disabled = _this$props.disabled,
        onUpdate = _this$props.onUpdate,
        readOnly = _this$props.readOnly,
        borderless = _this$props.borderless,
        checkout = _this$props.checkout,
        loading = _this$props.loading,
        errors = _this$props.errors;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.root, borderless && styles.borderless)
      }, loading ? /*#__PURE__*/React.createElement(ContentLoading, {
        compact: true
      }) : questions.map(function (question) {
        var answer = answers.find(function (a) {
          return a.id === question.id;
        });
        var change = function change(newAnswer) {
          return onChange(updateAnswers(answers, {
            id: question.id,
            newAnswer: newAnswer
          }));
        };
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: question.id
        }, /*#__PURE__*/React.createElement(Help, {
          error: getError(errors, question.id),
          className: styles.indent
        }), /*#__PURE__*/React.createElement(QuestionRenderer, {
          answer: answer ? answer.answer : null,
          question: question,
          readOnly: readOnly,
          onChange: change,
          onUpdate: onUpdate,
          disabled: disabled,
          checkout: checkout
        }));
      }));
    }
  }]);
}(React.Component)) || _class;
export { QuestionsEditor as default };
function updateAnswers(answers, _ref) {
  var id = _ref.id,
    newAnswer = _ref.newAnswer;
  return answers.some(function (x) {
    return x.id === id;
  }) ? answers.map(function (answer) {
    return answer.id === id ? _objectSpread(_objectSpread({}, answer), {}, {
      answer: newAnswer
    }) : answer;
  }) : [].concat(_toConsumableArray(answers), [{
    id: id,
    answer: newAnswer
  }]);
}
//# sourceMappingURL=index.js.map
